function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { Icon, Button, Tooltip } from "@blueprintjs/core";
export var viewColumn = {
  width: 35,
  noEllipsis: true,
  hideInMenu: true,
  immovable: true,
  type: "action",
  render: function render() {
    return /*#__PURE__*/React.createElement(Icon, {
      className: "dt-eyeIcon",
      icon: "eye-open"
    });
  }
};
export var openColumn = _extends({}, viewColumn, {
  render: function render(val, record, rowInfo, props) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: "Open"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick(e) {
        e.stopPropagation();
        props.onDoubleClick && props.onDoubleClick(rowInfo.original, rowInfo.index, props.history);
      },
      minimal: true,
      small: true,
      className: "dt-eyeIcon",
      icon: "document-open"
    }));
  }
});